import React from 'react'
import classnames from 'classnames'

const Title = ({ children, className, ...rest }) => (
  <h3
    className={classnames(
      'block text-3xl text-white text-left font-bold w-full mb-8 font-ownersWide uppercase',
      className
    )}
    {...rest}
  >
    {children}
  </h3>
)

export default Title
